import React, { memo, useMemo, useEffect, useRef } from 'react';
import { usePDF } from '@react-pdf/renderer';
import LeaderPdfDocument from '../LeaderPdfDocument';

/**
 * PdfWorker - Ein "Headless" PDF-Generator.
 * Er wird außerhalb der animierten UI-Hierarchie gerendert, 
 * um physikalisch von Layout-Shifts isoliert zu sein.
 */
const PdfWorker = memo(({ payload, onUrlReady }) => {
    const lastDataRef = useRef(null);

    // PDF Dokument basierend auf dem String-Payload erstellen (Extreme Identitäts-Stabilität)
    const pdfDocument = useMemo(() => {
        try {
            const data = JSON.parse(payload);
            
            lastDataRef.current = data;

            const { 
                assignments = [], 
                workers = [], 
                vehicles = [], 
                kolonnen = [], 
                options = {}, 
                companyName = '', 
                userName = '', 
                dateRange = {}, 
                dateMode = 'calendar', 
                exportDate = '',
                companyLoc: passedCompanyLoc = {}
            } = data;

            const companyLoc = passedCompanyLoc || {};



            return (
                <LeaderPdfDocument
                    assignments={assignments}
                    workers={workers}
                    vehicles={vehicles}
                    kolonnen={kolonnen}
                    options={options}
                    companyName={companyName}
                    userName={userName}
                    dateRange={dateRange}
                    dateMode={dateMode}
                    exportDate={exportDate}
                    companyLoc={companyLoc}
                />
            );
        } catch (e) {
            console.error('[PdfWorker] ❌ Error parsing payload', e);
            return null;
        }
    }, [payload]);

    const [instance] = usePDF({ document: pdfDocument });

    // Loop-Schutz: Wir melden die URL nur, wenn sie sich physisch geändert hat
    const lastReportedUrlRef = useRef(null);

    // Fortschritt an Parent melden
    useEffect(() => {
        if (!instance.loading && instance.url && lastReportedUrlRef.current !== instance.url) {
            lastReportedUrlRef.current = instance.url;
            onUrlReady(instance.url);
        }
    }, [instance.url, instance.loading, onUrlReady]);

    return null;
});

PdfWorker.displayName = 'PdfWorker';

export default PdfWorker;
